import { Box, Chip } from "@mui/material";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { Breadcrumbs, Container } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import SearchBar from "./SearchBar";
import NavMenu from "./NavMenu";
import { useUI } from "../../context/UIContext";

const Header = () => {
  const logo = `${process.env.PUBLIC_URL}/assets/images/logo.png`;
  const navigate = useNavigate();
  const { locationPathnames } = useUI();

  return (
    <>
      <NavMenu />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          py: 2,
          flexWrap: "wrap",
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="logo"
          sx={{
            height: 115,
            "&:hover": { cursor: "pointer" },
            py: { xs: 1, md: 0 },
          }}
          onClick={() => navigate("/")}
        />

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            maxWidth: 800,
          }}
        >
          <SearchBar />
        </Box>
      </Box>
      <Container sx={{ py: 2 }}>
        {locationPathnames.length > 0 && (
          <Box sx={{ ml: 2 }}>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {locationPathnames.map((path, index) => (
                <Box key={index}>
                  <Chip
                    clickable
                    component={RouterLink}
                    to={path.path}
                    label={path.name}
                  />
                </Box>
              ))}
            </Breadcrumbs>
          </Box>
        )}
      </Container>
    </>
  );
};

export default Header;
